import script from "./export-bulk.vue?vue&type=script&setup=true&lang=ts"
export * from "./export-bulk.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__